export var CustomerAppTypesVo;
(function (CustomerAppTypesVo) {
    CustomerAppTypesVo["WORK_ITEM_CUSTOMS_4"] = "CUSTOM_ITEM_CATEGORY_4";
    CustomerAppTypesVo["WORK_ITEM_CUSTOMS_5"] = "CUSTOM_ITEM_CATEGORY_5";
    CustomerAppTypesVo["MESSENGER"] = "MESSENGER";
    CustomerAppTypesVo["TASKS"] = "PROJECT_MANAGEMENT";
    CustomerAppTypesVo["TICKETS"] = "FEEDBACK_MANAGEMENT";
    CustomerAppTypesVo["FEATURES"] = "PRODUCT_MANAGEMENT";
    CustomerAppTypesVo["WEB_FORMS"] = "WEB_FORMS";
    CustomerAppTypesVo["WEB_PAGES"] = "WEB_PAGES";
    CustomerAppTypesVo["KNOWLEDGE_BASE"] = "KNOWLEDGE_BASE";
    CustomerAppTypesVo["CUSTOMER_PORTAL"] = "CUSTOMER_PORTAL";
    CustomerAppTypesVo["TIMESHEETS"] = "TIMESHEETS";
})(CustomerAppTypesVo || (CustomerAppTypesVo = {}));
//# sourceMappingURL=customer-app-types-vo.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/customer-apps/customer-app-types-vo.js
// module id = 928
// module chunks = 14